import { useMutation } from '@tanstack/react-query'
import { CreateImportBeatParams, createImportBeat } from 'supabase/importBeats'
import { queryClient } from 'utils'

/**
 * Add a beat. On success, refresh the Beats list AND the Applications
 * run-health banner: the banner reads the active beats with their created_at,
 * so a stale copy would judge a just-added beat as missing its runs.
 *
 * Errors are not swallowed: the caller uses `mutateAsync` and maps the raw
 * PostgREST error with `mapBeatError`.
 */
export const useCreateImportBeat = () => {
  return useMutation({
    mutationFn: (params: CreateImportBeatParams) => createImportBeat(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['importBeats'] })
      queryClient.invalidateQueries({ queryKey: ['importRunHealth'] })
    }
  })
}
